import { deviceDetector } from "@ospweb/sdk-ui";
import { hasVoiceAccess as resolveVoiceAccess } from "@/src/lib/bridge/filePermissions";
import { supportsWebVoiceRecording } from "./voiceSupport";
import { useAppFeatures } from "@/src/lib/bridge/useBridge";
import { useMemo } from "react";

/**
 * 检查是否有语音访问能力的自定义 Hook
 *
 * Native App 环境：
 * - 需要同时满足原生能力标识（appFeatures.voiceAccess）和 Web API 支持
 * - appFeatures.voiceAccess: 原生是否支持语音功能（权限处理）
 * - supportsWebVoiceRecording: WebView 是否支持语音采集 API
 *
 * Web 环境（浏览器直接访问）：
 * - 只检查浏览器 API 支持
 *
 * @returns {boolean} 是否显示语音按钮
 */
export function useHasVoiceAccess(): boolean {
  const appFeatures = useAppFeatures();

  return useMemo(() => {
    const isApp = deviceDetector.isApp();
    const webSupport = supportsWebVoiceRecording();
    // Native app: 同时检查原生能力标识和 Web API 能力
    if (isApp) {
      return resolveVoiceAccess(appFeatures) && webSupport;
    }

    // Web: 检查浏览器 API 支持
    return webSupport;
  }, [appFeatures]);
}
